import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import NippoTrendCell from '../components/NippoTrendCell'
import { changeSelectedTeam, loadTrendList, loadNippoList } from '../actions'
import dateFormat from 'dateformat'

class NippoSideMenu extends Component {
  componentWillMount() {
    const { loadTrendList, initialize } = this.props
    loadTrendList()

    const now = new Date()
    const today = dateFormat(now, "yyyy-mm-dd")
    const yesterday = dateFormat(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1), "yyyy-mm-dd")
    initialize({ 
      startDate: today,
      endDate: yesterday
    })
  }

  render() {
    const { teams, selectedTeams, changeSelectedTeam, nippoList, users, trendList, handleSubmit, loadNippoList } = this.props
    return (
      <div className="column sidemenu">
        <form onSubmit={handleSubmit(values => loadNippoList(values.startDate, values.endDate))} >
          <div className="field is-grouped">
            <div className="control is-expanded">
              <Field name="endDate" component="input" type="date" className="input is-small date" />
              <span> - </span>
              <Field name="startDate" component="input" type="date" className="input is-small date" />
            </div>
            <div className="control">
              <button type="submit" className="button is-small">更新</button>
            </div>
          </div>
        </form>
        <h4 className="title">チーム</h4>
        <div className="tags">
          {Object.keys(teams).map(key => {
            return (
              <button className={selectedTeams.includes(key) ? 'tag is-success' : 'tag'} key={key} onClick={() => changeSelectedTeam(key, selectedTeams, nippoList, users)}>
                {teams[key].name}
              </button>
            )
          })}
        </div>
        <h4 className="title">トレンド</h4>
        {Object.keys(trendList).map(trendId =>
          <NippoTrendCell key={trendId} nippoData={trendList[trendId]} />
        )}
      </div>
    )
  }
}

export default connect(
  state => ({
    teams: state.organization.teams,
    selectedTeams: state.nippo.selectedTeams,
    nippoList: state.nippo.nippoList,
    trendList: state.nippo.trendList,
    users: state.users
  }),
  { changeSelectedTeam, loadTrendList, loadNippoList }
)(reduxForm({ form: 'nippo' })(NippoSideMenu))


// WEBPACK FOOTER //
// ./src/components/NippoSideMenu.js